<template>
    <div class="main_wrap">
        <div class="formShow_table mb_100">
            <div class="blockHead flex_justify_between mt_20">
                <p class="blockTitle">
                    <span class="name">研究报告</span>
                    <span class="split">|</span>
                    <span class="value">共{{allTotal}}条数据</span>
                </p>
            </div>
            <div class="blockBox bc_white shadow">
                <ul class="detailTab mb_15">
                    <li class="tabItem"
                        :class="{'active':activeType==tab.value}"
                        v-for="(tab,index) in tabData"
                        :key="index"
                        @click="paramChange('reportType',tab.value)">
                        {{tab.label}}
                    </li>
                </ul>
                <div class="tableListWrap">
                    <ReportList :tableObj="tableObj"></ReportList>
                </div>
                <!-- 分页器 -->
                <Pagination style="margin-bottom:0;" :total="total" :pageSize="pageSize" @pageChange="val=>paramChange('page',val)"></Pagination>
            </div>
        </div>
    </div>
</template>
<script>
import ReportList from "./components/ReportList";
import ajaxService from '@/server/api.js'
export default {
    data(){
        return {
            tabData:[
                {label:'房企拿地周报',value:'1'},
                {label:'工程市场月报',value:'2'},
                {label:'全装修报告',value:'3'},
            ],
            activeType:'1',
            currentPage:1,//当前页数
            total:null,//表格列表总条数
            allTotal:null,//总报告数
            pageSize:null,//表格列表单页条数
            tableObj:{//表格数据
                tableHead:[
                    {
                        prop:'sTitle',
                        label:'报告标题',
                        align:'left',
                        width:650
                    },
                    {
                        prop:'iReportType',
                        label:'报告分类',
                        align:'left',
                    },
                    {
                        prop:'iPublishTime',
                        label:'发布时间',
                        align:'right',
                    },
                ],
                tableData: [],
            },   
        }
    },
    components: {
        ReportList
    },
    computed: {
        param(){
            return {
                page:this.currentPage,
                type:this.activeType
            }
        }
    },
    created() {
        this.initData()
        document.title="研究报告 - 优采大数据"
    },
    methods: {
        // 初始化数据
        initData(){
            this.getListData(this.param)//获取报告列表
        },

        // 报告类型改变||page页数改变
        paramChange(type,value){
            console.log('参数改变',type,value)
            switch(type){
                case 'page':
                    this.currentPage=value;
                    break;
                case 'reportType'://切换报告类型时，需要重置currentPage 为 1
                    this.currentPage=1;
                    this.activeType=value;
                    break;
            }
            this.getListData(this.param)
        },

        // 获取报告列表
        getListData(param){
            ajaxService.getReportList(param).then(res=>{
                console.log('报告列表',res)
                if(!res.ErrorCode){
                    this.tableObj.tableData=res.Data.aList.map((item)=>{
                        let reportType = '';
                        this.tabData.forEach(tab=>{
                            if(tab.value==item.iReportType){
                                reportType=tab.label
                            }
                        })
                        return {
                            iPublishTime:item.iPublishTime,
                            sTitle:item.sTitle,
                            iReportType:reportType,
                            iAutoID:item.iAutoID,
                        }
                    })
                    this.total=Number(res.Data.iTotal)
                    this.allTotal=Number(res.Data.iAllTotal)
                    this.pageSize=res.Data.iPageSize
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.detailTab{
    margin-top:.1rem;
}
.tableListWrap{
    padding: .12rem;
    background: #F4F7FA;
    box-sizing: border-box;
    width:100%;
}
</style>
